import React from 'react'
// icons
import { VscGithubInverted } from 'react-icons/vsc';
import { VscMail } from 'react-icons/vsc';
import { ImLinkedin2 } from "react-icons/im";

function RightContent() {
	return (
		<div className="Panel-right">
      		<div></div>
          	<ul>
				<a href="https://github.com/jguzz">
				<VscGithubInverted />
				</a>
				<a href="https://www.linkedin.com/in/joseph-a-guzzardo/">
				<ImLinkedin2 />
				</a>
				<a href="mailto: joseph.a.guzzardo@gmail.com">
				<VscMail />
				</a>
          </ul>
        </div>
	)
}

export default RightContent